export const STORAGE_KEYS = {
  SIGN_UP_SYNC: 'apollo-sign-up-sync',
  CUSTOMER_ID: 'apollo-customer-id',
  PG_GOALS_LIST_SHRINK: 'apollo-pg-goals-list-shrink',
  PG_GOALS_SHOW_UNOPTIMISED_BANNER: 'apollo-pg-goals-show-unoptimised-banner',
  PG_CAMPAIGNS_LIST_SHRINK: 'apollo-pg-campaigns-list-shrink',
  PG_MANAGE_CAMPAIGNS_LIST_SHRINK: 'apollo-pg-manage-campaigns-list-shrink',
  PG_MANAGE_CAMPAIGNS_PG_LIST_SHRINK: 'apollo-pg-manage-campaigns-pg-list-shrink',
  WIZARD_KEYFIGURES: 'apollo-wizard-keyfigures',
  WIZARD_MONITOR: 'apollo-wizard-monitor',
  WIZARD_RULES: 'apollo-wizard-rules',
  WIZARD_SUGGESTIONS: 'apollo-wizard-suggestions',
  WIZARD_BUDGET_SUGGESTIONS: 'apollo-wizard-budget-suggestions',
  WIZARD_PRODUCTS: 'apollo-wizard-products',
  WIZARD_GOALS: 'apollo-wizard-goals',
  WIZARD_GOALS_EMPTY: 'apollo-wizard-goals-empty',
  WIZARD_GOALS_START: 'apollo-wizard-goals-start',
  RULES_BANNER: 'apollo-rules-banner',
  BUDGET_SUGGESTIONS_BANNER: 'apollo-budget-suggestions-banner',
};
